import { useState } from 'react'
import { Modal } from '@/components/common/Modal'
import { Button } from '@/components/common/Button'
import { CalendarDays } from 'lucide-react'
import { ValidityPeriodPicker } from './ValidityPeriodPicker'

interface ImportValidityDialogProps {
  isOpen: boolean
  title: string
  description: string
  entryCount?: number
  teacherCode?: string
  onConfirm: (validFrom: string | null, validTo: string | null) => void
  onCancel: () => void
}

export function ImportValidityDialog({
  isOpen,
  title,
  description,
  entryCount,
  teacherCode,
  onConfirm,
  onCancel,
}: ImportValidityDialogProps) {
  const [validFrom, setValidFrom] = useState('')
  const [validTo, setValidTo] = useState('')

  const handleConfirm = () => {
    onConfirm(validFrom || null, validTo || null)
  }

  return (
    <Modal isOpen={isOpen} onClose={onCancel} title={title} size="lg">
      <div className="space-y-4">
        <div className="flex items-center gap-2 text-blue-600">
          <CalendarDays className="h-5 w-5" />
          <span className="text-sm">{description}</span>
        </div>

        {(entryCount !== undefined || teacherCode) && (
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 text-sm text-gray-600">
            {teacherCode && <div><strong>Lehrer:</strong> {teacherCode}</div>}
            {entryCount !== undefined && <div><strong>Einträge:</strong> {entryCount}</div>}
          </div>
        )}

        <ValidityPeriodPicker
          validFrom={validFrom}
          validTo={validTo}
          onChange={(from, to) => {
            setValidFrom(from)
            setValidTo(to)
          }}
        />

        <div className="flex justify-end gap-2 pt-4 border-t">
          <Button variant="secondary" size="sm" onClick={onCancel}>
            Abbrechen
          </Button>
          <Button size="sm" onClick={handleConfirm}>
            Bestätigen
          </Button>
        </div>
      </div>
    </Modal>
  )
}
